/** 右欄非需求物料統一群組（僅 UI；不進 payload）。 */
export const OTHER_MATERIAL_GROUP_KEY = '__OTHER__';
export const OTHER_MATERIAL_GROUP_NAME = '其他物料';
